import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type NoteFragment = { id: string, title?: string | null, description?: string | null, plainText?: string | null, rootBlockId?: string | null, status?: Types.NoteStatusTypeEnum | null, reviewConfig?: { reviewStatus?: Types.NoteReviewStatusTypeEnum | null } | null };


export type NoteFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type NotesQueryVariables = Types.Exact<{
  input: Types.PaginatedNotesInput;
}>;


export type NotesQuery = { notes: { edges?: Array<{ node: { id: string, title?: string | null, description?: string | null, plainText?: string | null, rootBlockId?: string | null, status?: Types.NoteStatusTypeEnum | null, reviewConfig?: { reviewStatus?: Types.NoteReviewStatusTypeEnum | null } | null } }> | null } };

export const NoteFragmentDoc = /*#__PURE__*/ gql`
    fragment Note on NoteType {
  id
  title
  description
  plainText
  rootBlockId
  status
  reviewConfig {
    reviewStatus
  }
}
    `;
export const NotesDocument = /*#__PURE__*/ gql`
    query notes($input: PaginatedNotesInput!) {
  notes(input: $input) {
    edges {
      node {
        ...Note
      }
    }
  }
}
    ${NoteFragmentDoc}`;

export function useNotesQuery(options: Omit<Urql.UseQueryArgs<NotesQueryVariables>, 'query'>) {
  return Urql.useQuery<NotesQuery, NotesQueryVariables>({ query: NotesDocument, ...options });
};